import BaseAPI from "../baseAPI"

class RestaurantAPI extends BaseAPI {
  constructor() {
    super("/restaurants")
  }

  getMenus() {
    return this.get("/menus")
  }

  getSpecialEvents() {
    return this.get("/special-events")
  }

  createReservation(data) {
    return this.post("/create-reservation", data)
  }
}

export { RestaurantAPI as default }